import { escape, unescape } from 'lodash'
import { type Renderer, marked } from 'marked'

// Inspired by https://github.com/ejrbuss/markdown-to-txt
const block = (text: string) => `${text}\n\n`
const escapeBlock = (text: string) => `${escape(text)}\n\n`
const line = (text: string) => `${text}\n`
const inline = (text: string) => text
const newline = () => '\n'
const empty = () => ''

const PlainTextRenderer: Renderer = {
  // Block elements
  code: escapeBlock,
  blockquote: block,
  html: empty,
  heading: block,
  hr: newline,
  list: (text) => block(text.trim()),
  listitem: line,
  checkbox: empty,
  paragraph: block,
  table: (header, body) => line(header + body),
  tablerow: (text) => line(text.trim()),
  tablecell: (text) => `${text} `,
  // Inline elements
  strong: inline,
  em: inline,
  codespan: inline,
  br: newline,
  del: inline,
  link: (_0, _1, text) => text,
  image: (_0, _1, text) => text,
  text: inline,
  // etc.
  options: {},
}

export const convertToPlaintext = (data: string) =>
  unescape(marked(data ?? '', { renderer: PlainTextRenderer })).trim()
